import { Route, Routes, useNavigate } from "react-router-dom";
import { Card } from "@mui/material";

import BudgetsKanban from "./kanban";
import BudgetDetails from "./budgetDetails";
import BudgetEdit from "./budgetEdit";
import BudgetManagerEdit from "./budgetEdit/index-manager";
import BudgetCreate from "./budgetCreate";

interface IBudgetsRoutesProps {
  persona: string;
  onClose?: () => void;
}

const BudgetsRoutes = (props: IBudgetsRoutesProps) => {
  const navigate = useNavigate();
  const onClose = props.onClose ?? (() => navigate(-1));
  const routeProps = { ...props, onClose };

  return (
    <Routes>
      <Route path="" element={<BudgetsKanban {...routeProps} />} />
      <Route path="/create" element={<Card className="w-full p-4 my-8 max-w-[2048px] mx-auto"><BudgetCreate {...routeProps} /></Card>} />
      <Route path="/:budgetId/versions/:version/details" element={<Card className="w-full p-4 my-8 max-w-[2048px] mx-auto"><BudgetDetails {...routeProps} /></Card>} />
      <Route path="/:budgetId/versions/:version/edit" element={<Card className="w-full p-4 my-8 max-w-[2048px] mx-auto"><BudgetEdit {...routeProps} /></Card>} />
      <Route path="/:budgetId/versions/:version/edit-manager" element={<Card className="w-full p-4 my-8 max-w-[2048px] mx-auto"><BudgetManagerEdit {...routeProps} /></Card>} />
    </Routes>
  );
};

export default BudgetsRoutes;
